import { useQuery } from '@tanstack/react-query';
import type { Report } from '@seo/types';
import { apiGet } from '@/lib/api';
import { isTerminal } from '@/lib/queryClient';

export function useReport(id: string | undefined) {
  return useQuery({
    queryKey: ['report', id],
    queryFn: () => apiGet<Report>(`/v1/reports/${id}`),
    enabled: !!id,
    refetchInterval: (q) => (isTerminal(q.state.data?.status) ? false : 5_000),
  });
}
